module.exports = __webpack_public_path__ + "fd1e1b6d9aea9b77a4dc50c20b94a78c.png";